export default __webpack_public_path__ + "static/media/stairs-up.inline.9f6c1d73.svg";